import {
  PricebookReport,
  ProgressData,
  Progress3nuData,
  SummedReport,
} from '../../../models/ReportData';
import { findPricebookReportsByType } from './pricebookReportUtils';

function hasReportDataForKeys<T>(report: SummedReport, keys: (keyof T)[]): boolean {
  const hasTopLevelData = keys.some(key => report[key as keyof SummedReport] != null);
  if (hasTopLevelData) return true;

  const pricebookReports = findPricebookReportsByType(report);
  return pricebookReports.some(pricebookReport =>
    keys.some(key => pricebookReport[key as keyof PricebookReport] != null),
  );
}

const hasProgressData = (report: SummedReport): boolean => {
  const progressKeys: (keyof ProgressData)[] = [
    'acceptedTosCount',
    'onboardingCompletedCount',
    'budgetDetailsCompletedCount',
    'accountDetailsCompleteCount',
    'personalDetailsCompleteCount',
  ];

  const progress3nuKeys: (keyof Progress3nuData)[] = [
    'notStarted3nuCount',
    'zeroToTwentyFour3nuCount',
    'twentyFiveToSeventyFive3nuCount',
    'seventySixToNinetyNine3nuCount',
    'nuCompletedCount',
    'average3nuProgress',
  ];

  const hasStandardProgressData = hasReportDataForKeys<ProgressData>(report, progressKeys);
  const has3nuProgressData = hasReportDataForKeys<Progress3nuData>(report, progress3nuKeys);

  return hasStandardProgressData || has3nuProgressData;
};

export { hasReportDataForKeys, hasProgressData };
